require('./brokerETFsSellStep2ExAnteDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
} = require("utilities/currencyHelper");

// @ components
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const {
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    CHARGE_ACCOUNT_PREFIX
} = require("constants/index");
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerETFsSellStep2ExAnteDetails extends React.Component {
    buildRightSide() {
        const { immBrokerETFsSell } = this.props;
        return immBrokerETFsSell
            .get("exAnteData")
            .map((item, index) => (
                <BrokerExAntSection
                    context="brokerETFsSell"
                    eventCategory="orden venta acciones/paso 2"
                    section={item}
                    key={index}
                    complexTooltip={true}
                />
            ));
    }

    buildContent() {
        const {
            productCurrency,
            productFile,
            step1,
            stockContract,
            stockDescription,
            immBrokerETFsSell,
        } = this.props;
        const market = !!productFile.get("marketName")
            ? productFile.get("marketName").trim()
            : "";
        const stockToSell = `${stockDescription} ${market}`;
        const sharesAmount = step1.get('titleQuantity', 0);
        const sellPrice = step1.get('sellPrice', 0);
        let estimatedAmount = `${formatWithoutRound(sharesAmount*sellPrice)} ${formatCurrency(productCurrency)}`
        const estimatedBaseAmount = immBrokerETFsSell.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = immBrokerETFsSell.get('estimatedBaseAmountExchanged');
        if(!!estimatedBaseAmount){
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue=estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency=estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }
        const orderTypeOption = step1.get('orderTypeOption');
        let orderType;
        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderType = formatText('broker-stocksSellOrderTypeOption1');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderType = formatText('broker-stocksSellOrderTypeOption2');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                const currency = formatCurrency(productCurrency)
                const limitValueText = formatAmount(
                    step1.get("orderTypeValue"),
                    undefined,
                    BROKER_TYPE_STOCKS_NEW_DECIMALS
                ).toString();
                orderType = formatText('broker-stocksSellOrderTypeOption3', [limitValueText, currency]);
                break;
            default:
                orderType = '-'
                break;
        }
        const validityDate = !!step1.get("validityDate")
            ? step1.get("validityDate")
            : null;
        const formattedValidityDate = !!validityDate
            ? validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
            : '-';

        const contractValues = `${CHARGE_ACCOUNT_PREFIX}${stockContract.get(
            "controlDigit"
        )}${stockContract.get("productNumber")}${stockContract.get(
            "walletNumber"
        )}`
        const accountType = stockContract.get('associatedAccountAlias');
        const accountNumber =stockContract.get('associatedAccount');
        const walletBalance = stockContract.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = stockContract.getIn(['associatedAccountBalance', 'currency']);
        const accountBalance = `${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)}`
        const accountDetails = formatText(
            "brokerStocksSells-asociatedAccountDetails",
            [accountType, accountNumber, accountBalance]
        );


        return (
            <div className="stocks-sell-step2-exante__container">
                <div className="stocks-sell-step2-exante__left">
                    <div className="stocks-sell-step2-exante__subtitle">
                        <FormattedText value="brokerInternalTransferFund-ExantCost_OrderDataSubtitle" />
                    </div>
                    <BrokerDataItem
                        label="brokerETFsSell-ETFToSellLabel"
                        data={stockToSell}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-estimatedAmountLabel"
                        data={estimatedAmount}
                        tooltipTitleKey="brokerETFsSell-estimatedAmountTooltipTitle"
                        tooltipContentKey="brokerETFsSell-estimatedAmountComplexTooltipContent"
                        eventCategory="orden venta ETF/paso 2"
                        eventTag={formatText("brokerETFsSell-orderData_estimatedAmount_eventTag")}
                        complexTooltip
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-sharesLabel"
                        data={sharesAmount}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-orderTypeLabel"
                        data={orderType}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-validityPeriodLabel"
                        data={formattedValidityDate}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-contractLabel"
                        data={contractValues}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-firstOwnerLabel"
                        data={stockContract.get('firstTitular')}
                    />
                    <BrokerDataItem
                        label="brokerETFsSell-asociatedAccountLabel"
                        data={accountDetails}
                    />
                </div>
                <div className="stocks-sell-step2-exante__right">
                    {this.buildRightSide()}
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerETFsSell } = this.props;
        if(immBrokerETFsSell.get('exAnteDataFetching')){
            return <LoadingSection/>
        }
        const content = this.buildContent();
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="stocks-sell-step2-exante__cc-container">
                <div className="stocks-sell-step2-exante__cc-header-text">
                    <FormattedText value="brokerETFsSell-subtitleCC" />
                </div>
                {content}
                <div className="stocks-sell-step2-exante__cc-footer-text">
                    <FormattedText value="brokerETFsSell-footerTextCC" />
                </div>
            </BlockInfo>
        ) : (
            <div>
                <div className="stocks-sell-step2-exante__header-text">
                    <FormattedText value="brokerETFsSell-subtitle" />
                </div>
                {content}
            </div>
        );
    }

}

BrokerETFsSellStep2ExAnteDetails.propTypes = {
    productCurrency: PropTypes.string,
    productFile: PropTypes.object,
    step1: PropTypes.object,
    immBrokerETFsSell: PropTypes.object,
    stockContract: PropTypes.object,
    stockDescription: PropTypes.string,
}



module.exports = BrokerETFsSellStep2ExAnteDetails;